import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { MaterialModule } from "../../../components/material/material.module";
import { CrearItemComponent } from "./crear-item/crear-item.component";
import { CrearItemDialog } from "./crear-item/crear-item-dialog/crear-item-dialog.component";
import { EditarItemComponent } from "./editar-item/editar-item.component";
import { EditarItemDialog } from "./editar-item/editar-item-dialog/editar-item-dialog.component";
import { EliminarItemComponent } from "./eliminar-item/eliminar-item.component";
import { EliminarItemDialog } from "./eliminar-item/eliminar-item-dialog/eliminar-item-dialog.component";
import { ItemComponent } from "./item/item.component";
import { ListarItemsComponent } from "./listar-items/listar-items.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../../pipes/pipes.module";
import { TipoProductoService } from "../../../providers/tipo-producto.service";
import { AccesorioService } from "../../../providers/accesorio.service";
import { MostrarItemModule } from "./mostrar-item/mostrar-item.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MostrarItemModule
    ],
    declarations: [
        CrearItemComponent,
        CrearItemDialog,
        EditarItemComponent,
        EditarItemDialog,
        EliminarItemComponent,
        EliminarItemDialog,
        ItemComponent,
        ListarItemsComponent,
    ],
    entryComponents: [
        CrearItemDialog,
        EditarItemDialog,
        EliminarItemDialog,
    ],
    exports: [
        CrearItemComponent,
        EditarItemComponent,
        EliminarItemComponent,
        ItemComponent,
        ListarItemsComponent,
        MostrarItemModule,
    ],
    providers: [
        AccesorioService,
        TipoProductoService,
    ]
})
export class ItemModule { }